import { Trans } from '@/utils/translation'
import store from '@/store'
console.log(store.getters['user/loggedIn'])
export default [
  {
    path: '/:lang',
    beforeEnter: Trans.routeMiddleware,
    component: {
      template: `<router-view></router-view>`
    },
    children: [
      {
        path: '',
        name: 'Home',
        meta: { authRequired: true },
        component: () => lazyLoadPage(import('@/pages/home/PageHome'))
      },
      {
        path: 'register',
        name: 'Register',
        meta: { authRequired: true },
        component: () => lazyLoadPage(import('@/pages/auth/PageRegister'))
      },
      {
        path: 'signin',
        name: 'SignIn',
        component: () => lazyLoadPage(import('@/pages/auth/PageSignIn')),
        beforeEnter: (to, from, next) => {
          if (store.getters['user/loggedIn']) {
            next({ name: 'Home', params: { lang: to.params.lang } })
          } else {
            next()
          }
        }
      },
      {
        path: 'signout',
        name: 'SignOut',
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
          store.dispatch('user/signOut').then(() => {
            next({
              name: 'SignIn',
              params: { lang: to.params.lang },
              query: { redirectFrom: from.fullPath }
            })
          })
        }
      },
      {
        path: 'change',
        name: 'Change',
        meta: { authRequired: true },
        component: () => lazyLoadPage(import('@/pages/auth/PageChangePassword'))
      },
      {
        path: 'airticket',
        meta: { authRequired: true },
        component: {
          template: `<router-view></router-view>`
        },
        children: [
          {
            path: 'create',
            name: 'AirticketCreate',
            component: () =>
              lazyLoadPage(import('@/pages/airticket/PageAirticketCreate'))
          },
          {
            path: 'transaction',
            name: 'AirticketSettledOrder',
            component: () =>
              lazyLoadPage(import('@/pages/order/PageSettledOrder'))
          },
          {
            path: 'transactionGroup',
            name: 'AirticketTransactionGroup',
            component: () =>
              lazyLoadPage(import('@/pages/order/PageTransactionGroup'))
          }
        ]
      },
      {
        path: 'individualTour',
        meta: { authRequired: true },
        component: {
          template: `<router-view></router-view>`
        },
        children: [
          {
            path: 'create',
            name: 'IndividualTourCreate',
            component: () =>
              lazyLoadPage(import('@/pages/individualTour/PageIndividualTourCreate'))
          },
          {
            path: 'transaction',
            name: 'IndiviTourSearch',
            component: () =>
              lazyLoadPage(import('@/pages/individualTour/PageSettledOrder'))
          }
        ]
      },
      {
        path: 'group',
        meta: { authRequired: true },
        component: {
          template: `<router-view></router-view>`
        },
        children: [
          {
            path: 'create',
            name: 'GroupTourCreate',
            component: () =>
              lazyLoadPage(import('@/pages/groupTour/PageGroupTourCreate'))
          },
          {
            path: 'transaction',
            name: 'GroupTourSearch',
            component: () =>
              lazyLoadPage(import('@/pages/groupTour/PageSettledOrder'))
          }
        ]
      },
      {
        path: 'management',
        meta: { authRequired: true },
        component: {
          template: `<router-view></router-view>`
        },
        children: [
          {
            path: 'employee/:page(\\d+)?',
            name: 'Employee',
            component: () =>
              lazyLoadPage(import('@/pages/management/PageEmployee'))
          },
          {
            path: 'wholesaler',
            name: 'Wholesaler',
            component: () =>
              lazyLoadPage(import('@/pages/management/PageWholesaler'))
          },
          {
            path: 'customersources',
            name: 'Source',
            component: () =>
              lazyLoadPage(import('@/pages/management/PageSource'))
          },
          {
            path: 'diary',
            name: 'Diary',
            component: () =>
              lazyLoadPage(import('@/pages/management/PageDiary'))
          }
        ]
      },
      {
        path: 'accounting',
        meta: { authRequired: true },
        component: {
          template: `<router-view></router-view>`
        },
        children: [
          {
            path: 'management',
            name: 'AccountingManagement',
            component: () =>
              lazyLoadPage(import('@/pages/accounting/PageAccounting'))
          },
          {
            path: 'indivTour',
            name: 'AccountingIndivTour',
            component: () =>
              lazyLoadPage(import('@/pages/accounting/PageAccountingIndivTour'))
          },
          {
            path: 'groupTour',
            name: 'AccountingGroupTour',
            component: () =>
              lazyLoadPage(import('@/pages/accounting/PageAccountingGroupTour'))
          }
        ]
      },
      {
        path: '',
        component: {
          template: `<router-view></router-view>`
        },
        children: [
          {
            path: 'success',
            name: 'CreateSuccess',
            component: () =>
              lazyLoadPage(import('@/pages/common/PageCreateSuccess'))
          },
          {
            path: 'success/individualtour',
            name: 'CreateSuccessIndividual',
            component: () =>
              lazyLoadPage(import('@/pages/common/PageCreateSuccess'))
          },
          {
            path: 'success/grouptour',
            name: 'CreateSuccessGroup',
            component: () =>
              lazyLoadPage(import('@/pages/common/PageCreateSuccess'))
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect (to) {
      return Trans.getUserSupportedLang()
    }
  }
]

function lazyLoadPage (AsyncPage) {
  const AsyncHandler = () => ({
    component: AsyncPage,
    // A component to use while the component is loading.
    // loading: require('@/pages/common/PageLoading').default,
    // Delay before showing the loading component.
    // delay: 400,
    // error: require('@/pages/common/PageError').default,
    timeout: 10000
  })

  return Promise.resolve({
    functional: true,
    render (h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/routes.js